import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import Mascot from "@/components/Mascot";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/app"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/app");
  };

  return (
    <div className="min-h-screen bg-[#0A0A0C] flex items-center justify-center p-4 relative overflow-hidden">
      <div className="absolute -top-40 -right-40 h-96 w-96 rounded-full bg-gold/10 blur-3xl" />
      <div className="absolute -bottom-40 -left-40 h-96 w-96 rounded-full bg-gold/5 blur-3xl" />

      <motion.div
        initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}
        className="relative w-full max-w-md">
        <div className="flex flex-col items-center mb-6">
          <Mascot size={120} />
          <h1 className="mt-3 text-3xl font-display font-extrabold tracking-tight text-white">
            Alpha<span className="alpha-gold-text">OS</span>
          </h1>
          <p className="text-sm text-zinc-500">Centro de comando · Alpha Prime</p>
        </div>

        <form onSubmit={submit} className="alpha-card p-7 space-y-4" data-testid="login-form">
          <div>
            <label className="text-xs text-zinc-400 mb-1.5 block">E-mail</label>
            <Input data-testid="login-email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="voce@alphaprime.com"
              className="bg-[#0A0A0C] border-white/10 focus-visible:ring-gold text-white h-11" />
          </div>
          <div>
            <label className="text-xs text-zinc-400 mb-1.5 block">Senha</label>
            <Input data-testid="login-password" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="••••••••"
              className="bg-[#0A0A0C] border-white/10 focus-visible:ring-gold text-white h-11" />
          </div>
          <Button data-testid="login-submit" type="submit" disabled={loading}
            className="w-full h-11 text-black font-semibold hover:opacity-90"
            style={{ background: "linear-gradient(135deg,#F3C64F,#D4AF37 55%,#AA820A)" }}>
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Entrar"}
          </Button>
          <p className="text-[11px] text-zinc-600 text-center pt-1">
            Sistema restrito · v1.3 congelada
          </p>
        </form>
      </motion.div>
    </div>
  );
}
